import { Helmet } from "react-helmet-async";
import { useParams, useLocation } from "react-router-dom";
import { supportedLngs } from "../i18n";

const langToLocale = {
  en: "en_US",
  es: "es_ES",
  de: "de_DE",
  ja: "ja_JP",
  fr: "fr_FR",
  pt: "pt_BR",
  ru: "ru_RU",
  it: "it_IT",
  nl: "nl_NL",
  pl: "pl_PL",
};

const DEFAULT_OG_IMAGE = "https://trackteam.app/TrackTeam/trackteamlogo.png";

export default function PageMeta({ title, description, schema, ogImage }) {
  const { lang } = useParams();
  const location = useLocation();
  const currentLang = lang && supportedLngs.includes(lang) ? lang : "en";
  const baseUrl = "https://trackteam.app";
  const canonicalUrl = `${baseUrl}${location.pathname}`;
  const pathWithoutLang = location.pathname
    .replace(new RegExp(`^/${currentLang}`), "")
    .replace(/^$/, "/");

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:locale" content={langToLocale[currentLang] || "en_US"} />
      <meta property="og:image" content={ogImage || DEFAULT_OG_IMAGE} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="TrackTeam" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage || DEFAULT_OG_IMAGE} />
      <link rel="canonical" href={canonicalUrl} />
      {supportedLngs.map((lng) => (
        <link
          key={lng}
          rel="alternate"
          hrefLang={lng}
          href={`${baseUrl}/${lng}${pathWithoutLang === "/" ? "" : pathWithoutLang}`}
        />
      ))}
      <link
        rel="alternate"
        hrefLang="x-default"
        href={`${baseUrl}/en${pathWithoutLang === "/" ? "" : pathWithoutLang}`}
      />
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}
